import styled from "styled-components";
import { Link } from "react-router-dom";
import { boxShadow, media } from "@nested/nested-react-components";

const Card = styled(Link)`
  width: 360px;
  height: 420px;
  display: flex;
  flex-direction: column;
  text-decoration: none;
  justify-content: center;
  align-items: center;
  padding: 40px;
  position: relative;
  background: ${(props) => props.color || "#fff"};
  ${boxShadow} border-radius: 5px;
  transition: all 0.2s ease;
  margin: 20px;

  ${media.lg`
    &:hover {
      transform: translateY(-10px);
      box-shadow: 0 10px 15px 0 rgba(0,0,0,.15);
      transition: all .2s ease;

      .title {
        background: ${(props) => props.theme.colors.primary.default};
        transition: all .2s ease;
      }
    }
  `};
`;

export { Card };
